// extracted by mini-css-extract-plugin
export var dropdownContainer = "_nd-0";
export var leftAlign = "_nd-4";
export var listItem = "_nd-2";
export var listItemWrapper = "_nd-1";
export var operationText = "_nd-3";